import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const nissimTrades: SeasonTrades[] = [
  {
    season: "2009/10",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Jason Kidd",
        gotInReturn: "Marcus Thornton",
      },
    ],
  },
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Danny Granger and Marcin Gortat",
        gotInReturn: "Carmelo Anthony and Raymond Felton",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Carmelo Anthony",
        gotInReturn: "Dirk Nowitzki and Steve Nash",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Raymond Felton",
        gotInReturn: "Marcus Camby",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Jarrett Jack",
        gotInReturn: "Carlos Boozer",
      },
    ],
  },

  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.itay,
        sentAway: "Dirk Nowitki and David Lee",
        gotInReturn: "Dwyane Wade and Luol Deng",
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Jonas Valanciunas and Reggie Jackson",
        gotInReturn: "Goran Dragic and Kenneth Faried",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Dwyane Wade",
        gotInReturn: "Kawhi Leonard",
        amongBestTrades: true
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Tim Duncan",
        gotInReturn: "Ricky Rubio",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Kevin Martin",
        gotInReturn: "Tyson Chandler",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Kendall Marshall",
        gotInReturn: "Spencer Hawes",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Goran Dragic and Brandon Knight",
        gotInReturn: "Michael Carter-Williams",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "DeMar DeRozan",
        gotInReturn: "Gorgui Dieng",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Kawhi Leonard",
        gotInReturn: "Damian Lillard and Serge Ibaka",
      },
      {
        otherTeam: manager.dom,
        sentAway: "LaMarcus Aldridge and Bradley Beal",
        gotInReturn: "Aaron Gordon",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Serge Ibaka",
        gotInReturn: "Dwight Howard",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Dwight Howard",
        gotInReturn: "Rudy Gay",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Aaron Gordon",
        gotInReturn: "Jayson Tatum",
        amongBestTrades: true,
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.itay,
        sentAway: "CJ McCollum",
        gotInReturn: "DeAndre Jordan",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Mo Bamba",
        gotInReturn: "DeMarcus Cousins",
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Khris Middleton",
        gotInReturn: "Lou Williams",
      },
    ],
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "James Harden and Jae'Sean Tate",
        gotInReturn: "Luka Doncic",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Pascal Siakam",
        gotInReturn: "LaMelo Ball and Steven Adams",
        amongBestTrades: true,
      },
    ],
  },
  { season: "2021/22", allTrades: [] },
  { season: "2022/23", allTrades: [] },
  {
    season: "2023/24",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "LaMelo Ball",
        gotInReturn: "Chet Holmgren",
        amongBestTrades: true
      }
    ]
  },
  {
    season: "2024/25",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Andre Drummond", 
        gotInReturn: "Yves Missi"
      },
    ]
  }
];
